import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { MODAL_TYPE_LOGIN } from '../../../../services/modal/constants';
import { APPLICATION_ID, HAS_INSTANT_DISCOUNT, NO_USER_ID, SSO_URL } from '../../../../constants';

import { showModal } from '../../../../services/modal/actions';

import useCartController from '../../../../services/ebon/hooks/useCartController';

import { getUserId, getClickId } from '../../../../utils/plebicardUtils';

import EbonSelectorLeftContainer from './EbonSelectorLeftContainer';
import EbonSelectorRightContainer from './EbonSelectorRightContainer';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import { EbonSelectorContainer } from './EbonSelectorComponentStyle';

const EbonSelectorComponent = ({ partner, i18n, fetching, ebonPaymentConfig, showModal }) => {
    const {
        cart,
        handleItemChange,
        getCartTotal,
        addItemCart,
        getCartQuantity
    } = useCartController();

    const userId = getUserId();
    const clickId = getClickId();

    const INSTANT_DISCOUNT_LOGIN_REQUIRED_IDS = ['68', '68-2', '146', '164', '166'];
    const loginRequired =
        (INSTANT_DISCOUNT_LOGIN_REQUIRED_IDS.includes(APPLICATION_ID) || !HAS_INSTANT_DISCOUNT) &&
        !NO_USER_ID &&
        (!userId || (userId && userId === '0')) &&
        !clickId;

    const cartTotalQuantity = getCartQuantity(cart);
    const basketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimit;
    const defaultBasketLimit = ebonPaymentConfig && ebonPaymentConfig.basketLimitDefault;
    const effectiveBasketLimit = basketLimit || defaultBasketLimit || undefined;

    const isBasketLimitReached = () => {
        return effectiveBasketLimit && cartTotalQuantity >= effectiveBasketLimit;
    };
    const getBasketLimitMessage = () => {
        if (basketLimit && cartTotalQuantity >= basketLimit) {
            return i18n.CAPPING_MESSAGE;
        }
        if (defaultBasketLimit && cartTotalQuantity >= defaultBasketLimit) {
            return i18n.DEFAULT_CAPPING_MESSAGE;
        }
        return undefined;
    };

    const showLoginModal = event => {
        event.preventDefault();
        showModal(MODAL_TYPE_LOGIN, {
            redirectUrl: SSO_URL
        });
        return false;
    };

    return (
        <EbonSelectorContainer className="container">
            {fetching && (
                <div className="loading-div">
                    <LoadingComponent />
                </div>
            )}

            {!fetching && (
                <React.Fragment>
                    <EbonSelectorLeftContainer
                        partner={partner}
                        cart={cart}
                        addItemCart={addItemCart}
                        cartTotalQuantity={cartTotalQuantity}
                        basketLimit={effectiveBasketLimit}
                        isBasketLimitReached={isBasketLimitReached}
                        getBasketLimitMessage={getBasketLimitMessage}
                        loginRequired={loginRequired}
                        showLoginModal={showLoginModal}
                    />
                    <EbonSelectorRightContainer
                        partner={partner}
                        cart={cart}
                        handleItemChange={handleItemChange}
                        getCartTotal={getCartTotal}
                        isBasketLimitReached={isBasketLimitReached}
                        loginRequired={loginRequired}
                        showLoginModal={showLoginModal}
                    />
                </React.Fragment>
            )}
        </EbonSelectorContainer>
    );
};

EbonSelectorComponent.propTypes = {
    partner: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.MERCHANTCARD.EBON_SELECTOR,
        fetching: state.ebon.ebonsFetching,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EbonSelectorComponent));



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/ebonselector/EbonSelectorComponent.js